/* tslint:disable */
/* eslint-disable */
export interface ConfigurationParameters {
  basePath?: string;
}
export class Configuration {
  public readonly basePath?: string;
  public constructor(params: ConfigurationParameters = {}) {
    this.basePath = params.basePath;
  }
}
